<template>
  <div style="display: flex; flex-direction: column; align-items: center; padding: 1.5rem 3vw; min-height: 100vh; box-sizing: border-box;">
    <!-- 返回按钮：统一样式，适配手机端位置 -->
    <div style="text-align: left; width: 100%; position: relative; margin-bottom: 1rem;">
      <div
          class="el-icon-back cursor-pointer"
          style="font-size: 1.5rem; line-height: 1.2rem; font-weight: bold; position: absolute; left: 0; top: 0.5rem; z-index: 10;"
          @click="onBack"
      ></div>
      <div style="font-size: clamp(1.5rem, 4vw, 1.8rem); line-height: 1.2; font-weight: bold; color: #b62d2e; text-align: left; padding-left: 1.5rem;">
        學習表現 Learning Performance
      </div>
<!--      <div style="display: flex; justify-content: center; margin-top: 0.5rem; margin-bottom: 1rem;">-->
<!--        <span style="width: 1rem; height: 1rem; background: #b62d2e; border-radius: 50%; margin-right: 1rem"></span>-->
<!--        <span style="width: 1rem; height: 1rem; background: #de5934; border-radius: 50%; margin-right: 1rem"></span>-->
<!--        <span style="width: 1rem; height: 1rem; background: #f1aa55; border-radius: 50%; margin-right: 1rem"></span>-->
<!--      </div>-->
    </div>

    <!-- 学生名称：适配手机端字体 -->
    <div style="font-size: clamp(1.2rem, 3vw, 2rem); line-height: 1.2; font-weight: bold; color: #b62d2e; text-align: center; width: 100%; margin-bottom: 1rem;">
      學生 Student：<span style="color: #444444; font-weight: normal; font-size: clamp(1rem, 2.5vw, 1.8rem);">{{ name }}</span>
    </div>
    <div class="model-box">
      <div
          :style="{
                    transform: isHomework ? 'translateX(100%)' : 'translateX(0%)',
                    width: '9.7rem',
                    height: '2.8rem'
                }"
          class="model-move"
      ></div>
      <div
          @click="isHomework = false"
          class="model-text cursor-pointer"
          :style="{
    color: isHomework ? '#B62D2E' : 'white',
    width: isMobile ? '8rem' : '10rem',
    fontSize: isMobile ? '0.9rem' : '1rem', // 修复：font-size → fontSize（驼峰）
    lineHeight: '1.2' // 可选：增加行高，避免文字重叠
  }"
      >
        冒險模式<br />Adventure Mode
      </div>
      <div
          @click="isHomework = true"
          class="model-text cursor-pointer"
          :style="{
    color: isHomework ? 'white' : '#B62D2E',
    width: isMobile ? '8rem' : '10rem',
    fontSize: isMobile ? '0.9rem' : '1rem', // 修复：font-size → fontSize
    lineHeight: '1.2'
  }"
      >
        作業<br />Homework
      </div>
    </div>

    <!-- 筛选区：手机端改为单列布局，优化间距 -->
    <div class="search-box">
      <el-row type="flex" align="bottom" :gutter="isMobile ? 8 : 10" style="flex-wrap: wrap;">
        <!-- 冒险模式筛选 -->
        <el-col :xs="24" :sm="12" :md="4" v-show="!isHomework">
          <div class="input-title">{{ isMobile ? '年級' : '年級 Grade' }}</div>
          <el-select @change="gradeChange" v-model="form.gradeId" clearable placeholder="全部" style="width: 100%">
            <el-option v-for="(item, index) in grades" :key="index" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="12" :md="4" v-show="!isHomework">
          <div class="input-title">{{ isMobile ? '星星' : '星星 Stars' }}</div>
          <el-select @change="starChange" v-model="form.star" clearable placeholder="全部" style="width: 100%">
            <el-option v-for="(item, index) in 4" :key="index" :label="index" :value="index"> </el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6" v-show="!isHomework">
          <div class="input-title">{{ isMobile ? '搜尋' : '搜尋 Search' }}</div>
          <el-input class="search" @input="keywordChange" :placeholder="isMobile ? '搜尋課題關鍵字' : '搜尋課題關鍵字 Search Chapter keywords'" v-model="form.keywords1" prefix-icon="el-icon-search"></el-input>
        </el-col>
        <el-col :xs="24" :sm="12" :md="4" v-show="!isHomework">
          <div class="input-title">{{ isMobile ? '語言' : '語言 Language' }}</div>
          <el-select @change="langChange" v-model="form.lang1" clearable placeholder="全部" style="width: 100%">
            <el-option v-for="(item, index) in langList" :key="index" :label="item" :value="index"> </el-option>
          </el-select>
        </el-col>

        <!-- 作业模式筛选 -->
        <el-col :xs="24" :sm="12" :md="4" v-show="isHomework">
          <div class="input-title">{{ isMobile ? '開始日期' : '開始日期 Start Date' }}</div>
          <el-date-picker align="center" v-model="form.startDate" type="date" :placeholder="isMobile ? 'DD/MM/YY' : 'DD/MM/YY'" format="dd/MM/yyyy" clearable style="width: 100%"> </el-date-picker>
        </el-col>
        <el-col :xs="24" :sm="12" :md="4" v-show="isHomework">
          <div class="input-title">{{ isMobile ? '結束日期' : '結束日期 End Date' }}</div>
          <el-date-picker align="center" v-model="form.endDate" type="date" :placeholder="isMobile ? 'DD/MM/YY' : 'DD/MM/YY'" format="dd/MM/yyyy" clearable style="width: 100%"> </el-date-picker>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6" v-show="isHomework">
          <div class="input-title">{{ isMobile ? '搜尋' : '搜尋 Search' }}</div>
          <el-input class="search" @input="keywordChange" :placeholder="isMobile ? '搜尋作業關鍵字' : '搜尋作業關鍵字 Search Homework keywords'" v-model="form.keywords2" prefix-icon="el-icon-search"></el-input>
        </el-col>
        <el-col :xs="24" :sm="12" :md="4" v-show="isHomework">
          <div class="input-title">{{ isMobile ? '語言' : '語言 Language' }}</div>
          <el-select @change="langChange" v-model="form.lang2" clearable placeholder="全部" style="width: 100%">
            <el-option v-for="(item, index) in langList" :key="index" :label="item" :value="index"> </el-option>
          </el-select>
        </el-col>

        <!-- 操作按钮：手机端占满宽度 -->
        <el-col :xs="24" :sm="24" :md="6" style="display: flex; padding-top: 0.625rem; gap: 10px;">
          <!-- 搜索按钮 -->
          <button
              @click="search"
              class="security-button cursor-pointer"
              style="background-color: #fcc03a; flex: 1; height: 3rem;"
              :style="{ fontSize: isMobile ? '0.9rem' : '1rem' }"
          v-html="isMobile ? '搜尋' : '搜尋<br />Search'"
          ></button>

          <!-- 清除筛选按钮 -->
          <button
              @click="clearSearch"
              class="security-button cursor-pointer"
              style="flex: 1; height: 3rem;"
              :style="{ fontSize: isMobile ? '0.9rem' : '1rem' }"
          v-html="isMobile ? '重置' : '重置<br />Reset'"
          ></button>
        </el-col>
      </el-row>
    </div>

    <!-- 内容区域：PC端表格，手机端卡片 -->
    <div class="summary-box">
      <!-- PC端表格 -->
      <div class="pc-content" v-show="!isMobile">
        <el-table class="is-topic" v-show="!isHomework" :data="topicData" style="width: 100%">
          <el-table-column prop="name" :label="'課題\nChapter'" min-width="180"> </el-table-column>
          <el-table-column :label="'語言\nLanguage'" width="140">
            <template slot-scope="{ row }">
              <span>{{ langList[row.lang] }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="'練習\nExercise'" width="130">
            <template slot-scope="{ row }">
              <span>{{ row.practiseCompletedQuantity + "/" + row.practiseTotalQuantity }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="star" width="220" align="center">
            <template slot="header">
              <div style="display: flex;align-items:end;justify-content:center">
                <div style="text-align: left;">{{'星星\nStars'}}</div>
                <el-popover
                    placement="top"
                    width="auto"
                    trigger="hover"
                    popper-class="show-toolTip"
                    :visible-arrow="false">
                  <img src="@/assets/images/Help.png" slot="reference" style="margin-left:0.5rem;display:block" />
                  <div style="margin:auto">
                    0 星 = 0 分<br />
                    0 星 = 未作答<br />
                    1 星 = 低過60分（1 - 60）<br />
                    2 星 = 低過100分（61 - 99）<br />
                    3 星 = 全對
                  </div>
                </el-popover>
              </div>
            </template>
            <template slot-scope="scope">
              <img :src="scope.row.star > 0 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
              <img :src="scope.row.star > 1 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
              <img :src="scope.row.star > 2 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
            </template>
          </el-table-column>
        </el-table>
        <el-table class="is-homework" v-show="isHomework" :data="homeworkData" style="width: 100%">
          <el-table-column prop="number" :label="'作業\nHomework'" min-width="340"> </el-table-column>
          <el-table-column :label="'語言\nLanguage'" width="150">
            <template slot-scope="{ row }">
              <span>{{ langList[row.lang] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="startDate" :label="'開始日期及時間\nStart Date and Time'" width="200" :formatter="startFormatter"> </el-table-column>
          <el-table-column prop="endDate" :label="'到期日期及時間\nEnd Date and Time'" width="200" :formatter="endFormatter"> </el-table-column>
          <el-table-column prop="completedAt" :label="'完成日期及時間\nFinish Date and Time'" width="200" :formatter="completedFormatter"> </el-table-column>
          <el-table-column :label="'分數\nScore'" width="140">
            <template slot-scope="{ row }">
              <span>{{ row.correctQuantity + "/" + row.totalQuantity }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 手机端卡片布局 -->
      <div class="mobile-content" v-show="isMobile">
        <!-- 冒险模式卡片 -->
        <div v-show="!isHomework" class="mobile-card-list">
          <div v-for="(item, index) in topicData" :key="index" class="mobile-card">
            <div class="card-header">
              <span class="card-title">{{ item.name }}</span>
              <span class="card-lang">{{ langList[item.lang] }}</span>
            </div>
            <div class="card-body">
              <div class="card-item">
                <span class="item-label">練習：</span>
                <span class="item-value">{{ item.practiseCompletedQuantity + "/" + item.practiseTotalQuantity }}</span>
              </div>
              <div class="card-item">
                <span class="item-label">星星：</span>
                <span class="item-value">
                                    <img :src="item.star > 0 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" style="width: 1.2rem; margin-right: 0.2rem;" />
                                    <img :src="item.star > 1 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" style="width: 1.2rem; margin-right: 0.2rem;" />
                                    <img :src="item.star > 2 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" style="width: 1.2rem;" />
                                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- 作业模式卡片 -->
        <div v-show="isHomework" class="mobile-card-list">
          <div v-for="(item, index) in homeworkData" :key="index" class="mobile-card">
            <div class="card-header">
              <span class="card-title">{{ item.number }}</span>
              <span class="card-lang">{{ langList[item.lang] }}</span>
            </div>
            <div class="card-body">
              <div class="card-item">
                <span class="item-label">開始時間：</span>
                <span class="item-value">{{ startFormatter(item) }}</span>
              </div>
              <div class="card-item">
                <span class="item-label">到期時間：</span>
                <span class="item-value">{{ endFormatter(item) }}</span>
              </div>
              <div class="card-item">
                <span class="item-label">完成時間：</span>
                <span class="item-value">{{ completedFormatter(item) }}</span>
              </div>
              <div class="card-item">
                <span class="item-label">分數：</span>
                <span class="item-value">{{ item.correctQuantity + "/" + item.totalQuantity }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页组件：适配手机端 -->
      <div style="width: 100%; margin-top: 1rem;">
        <Pagination
            v-show="!isHomework && total1 > 0"
            :small="isMobile ? true : false"
            :total="total1"
            :autoScroll="false"
            :page.sync="listQ._page1"
            :limit.sync="listQ._limit"
            @pagination="getTopics"
            layout="pager"
        />
        <Pagination
            v-show="isHomework && total2 > 0"
            :small="isMobile ? true : false"
            :total="total2"
            :autoScroll="false"
            :page.sync="listQ._page2"
            :limit.sync="listQ._limit"
            @pagination="getHomeworks"
            layout="pager"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getGrades } from "@/api/grade";
import { getHomeworks } from "@/api/homework";
import { getTopics } from "@/api/topic";
import { formatDateTime, formatDate2 } from "@/filters";
import Pagination from "@/components/Pagination";

export default {
  components: { Pagination },
  name: "home",
  data() {
    return {
      id: null,
      name: null,
      gradeId: null,
      isHomework: false,
      total1: 0,
      total2: 0,
      isMobile: false, // 标记是否为手机端
      langList: ['繁體中文', 'English'], // 补充语言列表
      form: {
        gradeId: null,
        star: null,
        keywords1: null,
        keywords2: null,
        startDate: null,
        endDate: null,
        lang1: null,
        lang2: null,
      },
      listQ: {
        _page1: 1,
        _page2: 1,
        _limit: 10,
      },
      grades: [],
      topicData: [],
      homeworkData: [],
    };
  },
  watch: {
    "$store.getters.language": {
      handler() {
        this.getGrades();
        this.$forceUpdate();
      },
      deep: true,
    },
  },
  created() {
    // 初始化参数
    if (!this.isEmpty(this.$route.query.id)) this.id = Number(this.$route.query.id);
    if (!this.isEmpty(this.$route.query.studentName)) this.name = this.$route.query.studentName;
    if (!this.isEmpty(this.$route.query.gradeId)) {
      this.gradeId = Number(this.$route.query.gradeId);
      this.form.gradeId = this.gradeId;
    }
    if (!this.isEmpty(this.$route.query.studying)) {
      this.form.lang1 = Number(this.$route.query.studying);
      this.form.lang2 = Number(this.$route.query.studying);
    }

    // 检测设备类型
    this.checkDevice();
    // 监听窗口大小变化
    window.addEventListener('resize', this.checkDevice);

    this.initial();
  },
  destroyed() {
    // 移除监听
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    // 返回上一页
    onBack() {
      this.$router.go(-1);
    },
    // 检测是否为手机端
    checkDevice() {
      this.isMobile = window.innerWidth < 768;
    },
    // 判空
    isEmpty(value) {
      return value === undefined || value === null || value === '';
    },
    initial() {
      this.getGrades();
      this.getHomeworks();
      this.getTopics();
    },
    startFormatter(row) {
      return formatDateTime(row.startDate) || "---";
    },
    endFormatter(row) {
      return formatDateTime(row.endDate) || "---";
    },
    completedFormatter(row) {
      return formatDateTime(row.completedAt) || "---";
    },
    enName(gradeName) {
      let enGradeList = {
        小一: "Primary One",
        小二: "Primary Two",
        小三: "Primary Three",
        小四: "Primary Four",
        小五: "Primary Five",
        小六: "Primary Six",
      };
      return enGradeList[gradeName];
    },
    getGrades() {
      getGrades().then((v) => {
        this.grades = v.data;
        this.$forceUpdate();
      });
    },
    getHomeworks() {
      let form = {
        studentId: this.id,
        gradeId: this.form.gradeId,
        startDate: formatDate2(this.form.startDate),
        endDate: formatDate2(this.form.endDate),
        keywords: this.form.keywords2,
        lang: this.form.lang2,
        _page: this.listQ._page2 - 1,
        _limit: this.listQ._limit,
      };
      getHomeworks(form).then((v) => {
        this.homeworkData = v.data;
        this.total2 = Number(v.headers["x-total-count"]);
      });
    },
    getTopics() {
      let form = {
        studentId: this.id,
        gradeId: this.form.gradeId,
        star: this.form.star,
        keywords: this.form.keywords1,
        lang: this.form.lang1,
        _page: this.listQ._page1 - 1,
        _limit: this.listQ._limit,
        orderBy: "number",
      };
      getTopics(form).then((v) => {
        this.topicData = v.data;
        this.total1 = Number(v.headers["x-total-count"]);
      });
    },
    gradeChange(id) {
      console.log(id);
    },
    starChange(value) {
      console.log(value);
    },
    langChange(lang) {
      console.log(lang);
    },
    keywordChange(str) {
      console.log(str);
    },
    search() {
      this.getTopics();
      this.getHomeworks();
    },
    clearSearch() {
      this.form = {
        gradeId: "",
        star: "",
        keywords1: "",
        keywords2: "",
        startDate: "",
        endDate: "",
        lang1: "",
        lang2: "",
      };
      let form = {
        studentId: this.id,
        _page: 0,
        _limit: this.listQ._limit,
        orderBy: "number",
      };
      getTopics(form).then((v) => {
        this.topicData = v.data;
        this.total1 = Number(v.headers["x-total-count"]);
        this.listQ._page1 = 1;
      });
      getHomeworks(form).then((v) => {
        this.homeworkData = v.data;
        this.total2 = Number(v.headers["x-total-count"]);
        this.listQ._page2 = 1;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// 定义断点
$mobileMaxWidth: 767px;
$tabletMinWidth: 768px;
$tabletMaxWidth: 991px;

// 模式切换按钮
.model-box {
  display: flex;
  text-align: center;
  background: white;
  border: 1px #b62d2e solid;
  border-radius: 2rem;
  padding: 0.25rem;
  margin: 1rem 0;
  font-family: "GenSenRoundedTW", "Helvetica", "Arial";
  position: relative;
  width: 100%;
  max-width: 20rem;
}
.model-move {
  position: absolute;
  transition: transform 0.4s linear 0s;
  border-radius: 2rem;
  background: #b62d2e;
}
.model-text {
  padding: 0.25rem 0;
  color: #b62d2e;
  z-index: 1;
  cursor: pointer;
  flex: 1;
}

// 筛选区样式
.input-title {
  color: #8e8e8e;
  font-weight: 500;
  line-height: 1.6rem;
  margin-bottom: 0.3rem;
}
.security-button {
  border: 0.0625rem solid #fcc03a;
  background-color: #ffffff;
  font-weight: bold;
  color: #444444;
  border-radius: 1.625rem;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.search-box {
  font-size: 0.875rem;
  width: 100%;
  margin: 1rem 0;
}
.summary-box {
  width: 100%;
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

// PC端内容默认显示，手机端隐藏
.pc-content {
  display: block;
  width: 100%;
}
// 手机端内容默认隐藏，手机端显示
.mobile-content {
  display: none;
  width: 100%;
}

// 手机端核心样式
@media (max-width: $mobileMaxWidth) {
  // 切换内容显示
  .pc-content {
    display: none;
  }
  .mobile-content {
    display: block;
  }

  // 手机端卡片列表
  .mobile-card-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  // 单个卡片样式
  .mobile-card {
    background: #fff;
    border-radius: 1rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    padding: 1rem;
    width: 100%;
    box-sizing: border-box;
  }

  // 卡片头部
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 0.8rem;
    border-bottom: 1px solid #fceedd;
    margin-bottom: 0.8rem;
  }
  .card-title {
    font-size: 1rem;
    font-weight: 500;
    color: #444;
  }
  .card-lang {
    font-size: 0.9rem;
    color: #8e8e8e;
    background: #fceedd;
    padding: 0.2rem 0.5rem;
    border-radius: 0.5rem;
  }

  // 卡片内容
  .card-body {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }
  .card-item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 0.9rem;
  }
  .item-label {
    color: #8e8e8e;
    min-width: 60px;
  }
  .item-value {
    color: #444;
    flex: 1;
  }

  // 筛选区优化
  .search-box {
    .el-col {
      margin-bottom: 0.8rem;
    }
  }

  // 按钮优化
  .security-button {
    height: 2.8rem !important;
    font-size: 0.9rem !important;
  }
}

// 平板端适配
@media (min-width: $tabletMinWidth) and (max-width: $tabletMaxWidth) {
  .model-box {
    max-width: 18rem;
  }
  .security-button {
    height: 3.2rem;
    font-size: 0.95rem;
  }
}

// 全局样式穿透
::v-deep {
  // 表单控件样式
  .el-select .el-input .el-select__caret {
    color: #444444;
  }
  .el-input__prefix,
  .el-input__suffix {
    color: #444444;
  }
  .el-date-editor {
    .el-input__prefix {
      left: auto;
      right: 5px;
    }
    .el-input__suffix {
      right: 25px;
    }
  }
  .el-input__inner {
    border-radius: 0.625rem;
    border: 0.0625rem solid #a1a1a1;
    padding-left: 0.5rem;
    height: 2.75rem;
    line-height: 2.75rem;
  }
  .search .el-input__inner {
    padding-left: 30px;
  }
  .el-icon-search {
    background: url("~@/assets/images/search.png") center center/contain no-repeat;
  }
  .el-icon-search:before {
    content: "";
  }

  // PC端表格样式
  .el-table {
    font-size: 1rem;
    width: 100%;
  }
  .el-table .cell {
    padding: 0.5rem;
  }
  .el-table th.el-table__cell > .cell {
    padding: 0.5rem;
    white-space: pre-wrap;
  }
  .el-table th {
    background: #fceedd;
    color: #444444;
    font-weight: 500;
  }
  .el-table th:first-child,
  .el-table td:first-child {
    padding-left: 1rem;
  }
  .el-table td:last-child {
    padding-right: 1rem;
  }

  // 分页组件适配
  .el-pagination {
    justify-content: center;
    .el-pager li {
      padding: 0 0.5rem;
    }
  }
}

// 通用样式
.cursor-pointer {
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
</style>